import { type Collaborators, type PublicAccess } from "@doitintl/cmp-models";
import { type AxiosInstance } from "axios";

import { type MetricWSnap } from "../../../types";

const getBaseURL = (customerId: string) => `/v1/customers/${customerId}/analytics/metrics`;

export const deleteMetrics = async (api: AxiosInstance, customerId: string, metricIds: string[]) => {
  const baseURL = getBaseURL(customerId);
  await api.delete(baseURL, {
    data: {
      ids: metricIds,
    },
  });
};

export const shareMetrics = async (
  api: AxiosInstance,
  customerId: string,
  metrics: MetricWSnap[],
  collaborators: Collaborators,
  publicAccess: PublicAccess
) => {
  await Promise.all(
    metrics.map((metric) =>
      api.request({
        method: "PATCH",
        url: `${getBaseURL(customerId)}/${metric.ref.id}/share`,
        data: {
          collaborators,
          public: publicAccess,
        },
      })
    )
  );
};
